import { trigger, transition, style, animate, query, group } from '@angular/animations';

export const routerTransition = trigger('routerTransition', [
    transition('* <=> *', [ // Applies to all route transitions
        // Initial state
        query(':enter, :leave', style({ position: 'absolute', width: '100%' }), { optional: true }),

        // Leave animation
        query(':leave', [
            animate('300ms ease-out', style({ opacity: 0, transform: 'translateX(-20px)' }))
        ], { optional: true }),

        // Enter animation
        query(':enter', [
            style({ opacity: 0, transform: 'translateX(20px)' }),
            animate('300ms ease-in', style({ opacity: 1, transform: 'translateX(0)' }))
        ], { optional: true })
    ])
]);
